module.exports = __webpack_public_path__ + "img/no-orders-illustration.33a88b4f.svg";